export default function DateLowerThanDirective($filter, utilitySevice) {
  'ngInject';

  return {
    require: 'ngModel',
    link(scope, elm, attrs, ctrl) {
      const validateDateRange = function (inputValue) {
        const fromDate = $filter('date')(inputValue, 'short');
        const toDate = $filter('date')(attrs.dateLowerThan, 'short');
        const isValid = utilitySevice.isValidDateRange(fromDate, toDate);
        ctrl.$setValidity('dateLowerThan', isValid);
        return inputValue;
      };

      scope.$watch(attrs.ngModel, (newValue) => {
        validateDateRange(newValue);
      });
    },
  };
}
